import styled from "styled-components/macro";

import {
  untaggedColor,
  waitingColor,
  unplannedColor,
  noProductionScheduledColor,
  producingColor,
  plannedColor,
  lightGrey,
  muiButtonText,
} from "../../constants/colors";
import {
  FONT_SIZE_EXTRA_SMALL,
  BREAKPOINT_MOBILE,
} from "../../constants/constants";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import { camelCase } from "lodash";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";

const colors = {
  left: [
    { title: "Untagged", color: untaggedColor },
    { title: "Waiting", color: waitingColor },
    { title: "Unplanned", color: unplannedColor },
  ],
  right: [
    { title: "Producing", color: producingColor },
    { title: "Planned", color: plannedColor },
    { title: "Not Scheduled", color: noProductionScheduledColor },
  ],
};

export const PNL_COLOR_SQUARE_BORDER = "1px solid rgba(0, 0, 0, 0.5)";

const ColorLegendStyles = styled.div`
  display: flex;
  .leftSide,
  .rightSide {
    display: flex;
    flex-direction: column;
    width: 116px;
    .row {
      display: flex;
      .title {
        flex-grow: 1;
        font-size: ${FONT_SIZE_EXTRA_SMALL}px;
        display: flex;
        align-items: center;
      }
      .colorSquare {
        min-width: 20px;
        min-height: 20px;
        margin: 3px 6px;
        border: ${PNL_COLOR_SQUARE_BORDER};
      }
    }
  }
  .border {
    width: 1px;
    background: ${lightGrey};
  }
  .leftSide {
    width: 124px;
    .title {
      justify-content: flex-end;
    }
  }
  margin: 10px 0 7px 0;
  @media (min-width: ${BREAKPOINT_MOBILE}px) {
    margin: 0 0 14px;
  }
`;

const ColorLegend = () => {
  const location = useLocation();
  const { pathname } = location;
  const { translate } = useFlightTranslation();
  const ckey = pathname && pathname.split("/")[1];
  return (
    <ColorLegendStyles>
      <div className="leftSide">
        {colors.left.map(({ title, color }) => (
          <div className="row" key={title}>
            <div className="title">{translate(camelCase(title))}</div>
            <div className="colorSquare" style={{ background: color }} />
          </div>
        ))}
      </div>
      <div className="border" />
      <div className="rightSide">
        {colors.right.map(({ title, color }) => (
          <div className="row" key={title}>
            <>
              {title.toLowerCase() === "producing" && ckey ? (
                <Link
                  className={"secretTrendsPageLink"}
                  to={`/${ckey}/trends`}
                  style={{
                    textDecoration: "none",
                    color: muiButtonText,
                  }}
                  key={title}
                >
                  <div className="colorSquare" style={{ background: color }} />
                </Link>
              ) : (
                <div className="colorSquare" style={{ background: color }} />
              )}
            </>
            <div className="title">{translate(camelCase(title))}</div>
          </div>
        ))}
      </div>
    </ColorLegendStyles>
  );
};

export default ColorLegend;
